const NAME = "CENTERS_SETTINGS_PAGE";

export default NAME;
